module.exports = __webpack_public_path__ + "b08e90a9f7aafbf31e9c174359bdd76d.pdf";